import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, HostBinding, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Observable, Subject, map } from "rxjs";
import { NGXLogger } from "ngx-logger";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { Stats } from "src/app/models/stats.model";


import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { StatsService } from "src/app/services/notification.service";
import { ImpreseService } from "src/app/services/imprese.service";

export let applicationVersionFromHome: string = "";

import { PraticaScuola_Firestore } from "src/app/models/praticaScuolaFirestore.model";
import { onSnapshot } from "firebase/firestore";
import { TabViewChangeEvent } from "primeng/tabview";
import { environment } from "src/environments/environment";
import { PraticaSanita_Firestore } from "src/app/models/praticaSanitaFirestore.model";
import { StatsFlowdy2 } from "src/app/models/statsFlowdy2.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";

import { v4 as uuidv4 } from 'uuid';
import { ImportLog_Firestore } from "src/app/models/firestore/importLogFirestore.model";

declare const CSVBoxImporter: any;

@Component({
  selector: "app-home-fase1",
  templateUrl: "./home.fase1.flowdy2.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeFase1Flowdy2Component implements OnInit, OnChanges {
  @Input() impresa: any;
  @Input() isImpresa: boolean = null;
  @Input() isPresidioTIM: boolean = null;
  @Input() isPresidioSF: boolean = null;
  @Input() isDemo: boolean = null;
  private importID: string; 

  private collection_pratiche:string  = environment.firebase.collection_pratiche;
  private collection_importLog:string = environment.firebase.collection_import_log;

  ref: DynamicDialogRef;

  protected isLoading:    boolean = false;

  protected isAdmin:      boolean = false;
  protected isSuperAdmin: boolean = false;
  //protected isPresidioSF: boolean = false;
  protected isDipendente: boolean = true;
  protected hasBando1:    boolean = false;
  protected hasBando2:    boolean = false;
  protected isPM:         boolean = false;
  protected isDirigenteFirmaPacchetti: boolean   = false;
  protected stats: StatsFlowdy2 = new StatsFlowdy2();

  //CSV BOX
  //private csvbox_licenseKey_aggiornaPraticheBando1:string=environment.csvBox.secret_aggiornaPraticheBando1;
  //private csvbox_licenseKey_aggiornaPraticheBando2:string=environment.csvBox.secret_aggiornaPraticheBando;
  private csvbox_licenseKey_comunicaEsitiConsegnaFase1:string=environment.csvBox.secret_comunicaEsitiConsegnaFase1;
  private csvbox_importer_aggiornaPraticheBando1:any;
  private csvbox_importer_comunicaEsitiConsegnaFase1:any;
  private csvbox_user:string=environment.csvBox.user;
  


  constructor(
    public auth: AuthService,
    private http: HttpClient,
    private messageService: MessageService,
    private dipendenteService: UtentiService,
    private impreseService: ImpreseService,

    private userService: UserService,
    public dialogService: DialogService,
    private logger: NGXLogger,
    private router: Router,
    public firestore: AngularFirestore,
    private statsService: StatsService,
    
    @Inject(DOCUMENT) private doc: Document
    

  ) {
    this.setUserRole();
  }

  setUserRole(){
    if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "ADMIN"
    ) {
      this.isAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SUPERADMIN"
    ) {
      this.isSuperAdmin = true;
    } else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "SMARTFIBER"
    ) {
      this.isPresidioSF = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PRESIDIO"
    ) {
      this.isPresidioTIM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
    ) {
      this.isImpresa = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "PM"
    ) {
      this.isPM = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
    ) {
      this.isDirigenteFirmaPacchetti = true;
    }else if (
      localStorage.getItem("ruolo") &&
      localStorage.getItem("ruolo") === "DEMO"
    ) {
      this.isDemo = true;
    }
  }

  ngOnInit() {
    this.logger.info("[HOME FASE 1] ON INIT");
    this.initCSVBox();
    this.setUserRole();
  }

  initCSVBox(){
   /*  this.csvbox_importer_aggiornaPraticheBando1 = new CSVBoxImporter(this.csvbox_licenseKey_aggiornaPraticheBando1, {
    }, (result: boolean, data: any) => {
      if (result) {
        this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});

      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 1 delle pratiche del bando 1', life:10000});
      }
    }); */
    this.csvbox_importer_comunicaEsitiConsegnaFase1 = new CSVBoxImporter(this.csvbox_licenseKey_comunicaEsitiConsegnaFase1, {
    }, (result: boolean, data: any) => {
      if (result) {
        //this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});
        this.readImportLog();
      } else {
        this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di caricamento degli esiti della consegna ad INFRATEL della FASE 1', life:10000});
      }
    });

    this.csvbox_importer_comunicaEsitiConsegnaFase1.setUser({
      user_id: "default123"
    });
    
    this.csvbox_importer_comunicaEsitiConsegnaFase1.language="it";
  
  }

  readImportLog(){
    const collectionRef = this.firestore.collection(this.collection_importLog).ref;
    let queryErrori ;
    queryErrori = collectionRef.where("id", "==", this.importID);
    
    onSnapshot(queryErrori, (qs) => {
      this.isLoading = false;
      qs.forEach((doc) => {
          let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
          if(!log.errori || log.errori.length == 0){
            if(!log.warning || log.warning.length == 0){
              if(log.numeroRecordNonProcessati!=0){
                if(log.numeroRecordNonProcessati==1){
                  this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata', life:10000});

                }else {
                  this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non sono state processate', life:10000});

                }
              }else{
                this.messageService.add({severity:'success', summary:'', detail: 'Tutte le ' + log.numeroTotaleRecord+ ' pratiche presenti nel file sono state processate con successo', life:10000});

              }

            }else{
              this.messageService.add({severity:'warn', summary:'Warning', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con '+ log.numeroRecordNonProcessati +' warning', life:10000});
            }
          }else{
            this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
          }
         
          
        });
    });
    
  }

  importaEsitiConsegnaAdInfratel(){
    this.importID = uuidv4();
    this.csvbox_importer_comunicaEsitiConsegnaFase1.setUser({
        importID: this.importID,
      });
    this.csvbox_importer_comunicaEsitiConsegnaFase1.openModal();
   
  }

  loadDatiBando1(){
   /*  if(this.isImpresa){
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 1 PER IMPRESA');
    }else if(this.isPresidioTIM){
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO TIM');
    }else{
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO');
    } */
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando1  ;
    if(this.isImpresa){
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 1 PER IMPRESA');
      queryBando1 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 1")
                   // .where("codiceStatoInfratelFase1", "!=", "1-6")
                    ;
     }else{
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 1 PER PRESIDIO/DEMO/ALTRO');
      queryBando1 = collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("codiceStatoInfratelFase1", "!=", "1-6")
              ;
    }
    onSnapshot(queryBando1, (qs) => {
      this.isLoading = false;
      //this.logger.info('[HOME FASE1] AGGIORNAMENTO DATI BANDO 1 '+ qs.docs.length);
      this.stats.resetBando1();
      //this.stats.bando1Fase1 =  qs.docs.length;
        qs.forEach((doc) => {
          let praticaBando1DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
          if(praticaBando1DaFirestore.statoFlowdyFase1!=='SOPRALLUOGO KO'){
            this.stats.bando1Fase1++;
            switch (praticaBando1DaFirestore.codiceStatoInfratelFase1) {
              case '1-1':
                if(!praticaBando1DaFirestore.showFase2){
                  if(!this.isPresidioTIM){
                    this.stats.bando1Fase1InLavorazione ++;
                  }
                  
                  this.stats.bando1Fase1_1 ++;
                  if(praticaBando1DaFirestore.lotto==='6'){
                    this.stats.bando1Fase1_1_lotto6++;
                  }else{
                    this.stats.bando1Fase1_1_lotto7++;
                  }
                }
               
                break;
              case '1-2':
                if(!this.isPresidioTIM){
                  this.stats.bando1Fase1InLavorazione ++;
                }
                this.stats.bando1Fase1_2 ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_2_lotto6++;
                }else{
                  this.stats.bando1Fase1_2_lotto7++;
                }
                break;
              case '1-3':
                this.stats.bando1Fase1InLavorazione ++;
                this.stats.bando1Fase1_3 ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_3_lotto6++;
                }else{
                  this.stats.bando1Fase1_3_lotto7++;
                }
                break;
              case '1-4':
                this.stats.bando1Fase1InLavorazione ++;
                this.stats.bando1Fase1_4 ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_4_lotto6++;
                }else{
                  this.stats.bando1Fase1_4_lotto7++;
                }
                break;
              case '1-5':
                if(!this.isPresidioTIM){
                  this.stats.bando1Fase1InLavorazione ++;
                }
                this.stats.bando1Fase1_5 ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_5_lotto6++;
                }else{
                  this.stats.bando1Fase1_5_lotto7++;
                }
                break;
              default:
                this.stats.bando1Fase1_6 ++;
                if(praticaBando1DaFirestore.lotto==='6'){
                  this.stats.bando1Fase1_6_lotto6++;
                }else{
                  this.stats.bando1Fase1_6_lotto7++;
                }
                break;
            }
          }
        });
    });
  }

  loadDatiBando2(){
   /*  if(this.isImpresa){
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 2 PER IMPRESA');
    }else if(this.isPresidioTIM){
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO TIM');
    }else{
      this.logger.info('[HOME FASE1] INIZIO CARICAMENTO DATI BANDO 2 PER PRESIDIO');
    } */
    this.isLoading = true;
    const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
    let queryBando2  ;
    if(this.isImpresa){
     queryBando2 = collectionRef
                    .where("idAzienda", "==", this.userService.getUser().azienda.id)
                    .where("bando", "==", "BANDO 2")
                    .where("codiceStatoInfratelFase1", "!=", "1-6");
    }else{
      queryBando2 = collectionRef
              .where("bando", "==", "BANDO 2");
             
    }

    onSnapshot(queryBando2, (qs) => {
      this.isLoading = false;
      this.stats.resetBando2();
      //this.stats.bando2Fase1 = qs.docs.length;
      

      qs.forEach((doc) => {
        let praticaBando2DaFirestore: PraticaFlowdy2_Firestore = doc.data() as PraticaFlowdy2_Firestore;
        if(praticaBando2DaFirestore.statoFlowdyFase1!=='SOPRALLUOGO KO'){
          this.stats.bando2Fase1++;
          switch (praticaBando2DaFirestore.codiceStatoInfratelFase1) {
            case '1-1':
              if(!this.isPresidioTIM){
                this.stats.bando2Fase1InLavorazione ++;
              }
              this.stats.bando2Fase1_1 ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase1_1_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase1_1_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase1_1_lotto7++;
              }else {
                this.stats.bando2Fase1_1_lotto8++;
              }
              break;
            case '1-2':
              if(!this.isPresidioTIM){
                this.stats.bando2Fase1InLavorazione ++;
              }
              this.stats.bando2Fase1_2 ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase1_2_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase1_2_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase1_2_lotto7++;
              }else {
                this.stats.bando2Fase1_2_lotto8++;
              }
              break;
            case '1-3':
              this.stats.bando2Fase1InLavorazione ++;
              this.stats.bando2Fase1_3 ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase1_3_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase1_3_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase1_3_lotto7++;
              }else {
                this.stats.bando2Fase1_3_lotto8++;
              }
              break;
            case '1-4':
              this.stats.bando2Fase1InLavorazione ++;
              this.stats.bando2Fase1_4 ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase1_4_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase1_4_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase1_4_lotto7++;
              }else {
                this.stats.bando2Fase1_4_lotto8++;
              }
              break;
            case '1-5':
              if(!this.isPresidioTIM){
                this.stats.bando2Fase1InLavorazione ++;
              }
              this.stats.bando2Fase1_5 ++;
              if(praticaBando2DaFirestore.lotto==='1'){
                this.stats.bando2Fase1_5_lotto1++;
              }else if(praticaBando2DaFirestore.lotto==='5'){
                this.stats.bando2Fase1_5_lotto5++;
              }else if(praticaBando2DaFirestore.lotto==='7'){
                this.stats.bando2Fase1_5_lotto7++;
              }else {
                this.stats.bando2Fase1_5_lotto8++;
              }
              break;
            default:
               // this.stats.bando2Fase1InLavorazione ++;
                this.stats.bando2Fase1_6 ++;
                if(praticaBando2DaFirestore.lotto==='1'){
                  this.stats.bando2Fase1_6_lotto1++;
                }else if(praticaBando2DaFirestore.lotto==='5'){
                  this.stats.bando2Fase1_6_lotto5++;
                }else if(praticaBando2DaFirestore.lotto==='7'){
                  this.stats.bando2Fase1_6_lotto7++;
                }else {
                  this.stats.bando2Fase1_6_lotto8++;
                }
                break;
          }
        }
        
        
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    /* if (changes['impresa'] && changes['impresa'].currentValue) {
      if(this.impresa===7){
        this.isImpresa = false;
       }else{
        this.isImpresa = true;
       }
       this.loadDatiBando1();
       this.loadDatiBando2();
    } */

    if (changes['impresa'] && changes['impresa'].currentValue) {
      this.impresa = changes['impresa'].currentValue;
    }
    if (changes['isImpresa'] && changes['isImpresa'].currentValue) {
      this.isImpresa = changes['isImpresa'].currentValue;
    }
    if (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) {
      this.isPresidioTIM = changes['isPresidioTIM'].currentValue;
    }
    if (changes['isDemo'] && changes['isDemo'].currentValue) {
      this.isDemo = changes['isDemo'].currentValue;
    }

    if( (changes['isImpresa'] && changes['isImpresa'].currentValue) 
      || (changes['isPresidioTIM'] && changes['isPresidioTIM'].currentValue) 
      || (changes['impresa'] && changes['impresa'].currentValue)
      || (changes['isDemo'] && changes['isDemo'].currentValue)
    ){
      this.logger.info('[HOME FASE1] ON CHANGES '+ this.isDemo);
      this.loadDatiBando1();
      this.loadDatiBando2();
    }
  }

  openPraticheFase1(bando:number, stato:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1/stato/1-'+stato]));
  }

  openAllPraticheFase1(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1']));
  }
  openPraticheFase1InLavorazione(bando:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1'],
      {
        queryParams: { 'in-lavorazione': true }, 
      }
    ));
  }
  openPraticheFase1PerLotto(bando:number, stato:number, lotto:number){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate(['pratiche-bando'+bando+'/fase-1/stato/1-'+stato],
      {
        queryParams: { 'lotto': lotto }, // Può essere true o false
      })
    );
  }

  aggiornaPratiche(bando:number){
    if(bando===1){
      this.csvbox_importer_aggiornaPraticheBando1.openModal();
    }else if(bando===2){
      //this.csvbox_importer_comunicaEsitiConsegnaBando2.openModal();
    }
  }
  
  
}
